import {resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import DoctorsService from "@services/DoctorsService";

export const viewDoctor = createAsyncThunk(
  "doctor/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await DoctorsService.viewDoctor({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  doctor: null,
  error: "",
  serverStatus: "",
};

const viewDoctorSlice = createSlice({
  name: "view-doctor",
  initialState,
  reducers: {
    setError(state, action) {
      state.error = action.payload;
    },
    setServerStatus(state, action) {
      state.serverStatus = action.payload;
    },
    clearViewDoctor() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(viewDoctor.pending, (state) => {
        state.serverStatus = "loading";
      })
      .addCase(viewDoctor.fulfilled, (state, action) => {
        state.doctor =
          action.payload?.doctor_profile ?? action.payload ?? null;
        state.error = "";
        state.serverStatus = "success";
      })
      .addCase(viewDoctor.rejected, (state, action) => {
        state.error = action.payload?.message || "";
        state.serverStatus = "error";
      });
  },
});

export const {clearViewDoctor, setError, setServerStatus} =
  viewDoctorSlice.actions;
export default viewDoctorSlice.reducer;
